import React from 'react';
import TestComponent from '../components/container/testComponent';

const Test = () => {
    return (
        <div className='container mx-auto'>
            <TestComponent />
        </div>
    );
}

export default Test;
